export default __webpack_public_path__ + "static/media/cipla-logo.bb251fe9.png";